import React from 'react';
import { TFunction } from 'i18next';
import Button, { ButtonTypes } from '@lib/components/Button/Button';
import { materialSymbolsOutlined } from '@lib/enums/common';

type Args = {
  // Optional: the user app's completions modal is read-only and has no
  // create-intervention entry point from here — omit it to drop the button
  // entirely rather than passing a no-op.
  onCreateInterventionSelected?: () => void;
  // Optional for the same reason: the user app doesn't open completion
  // details, compare view included.
  onCompareSelected?: () => void;
  selectedItemsCount: number;
  // Comparing needs at least two completions to pick from in the first
  // place — with a single completion for the whole task, the button would
  // have nothing meaningful to do.
  canCompare: boolean;
  t: TFunction<'translation', undefined>;
};

export default function getTaskCompletionsListActionsForSelected({
  onCreateInterventionSelected,
  onCompareSelected,
  selectedItemsCount,
  canCompare,
  t,
}: Args) {
  if (!selectedItemsCount) return [];
  return [
    ...(onCreateInterventionSelected
      ? [
          <Button
            key="create-intervention"
            buttonText={t('create-intervention')}
            buttonType={ButtonTypes.primaryOutlined}
            leftIcon="build"
            leftIconClassName={materialSymbolsOutlined}
            onClick={onCreateInterventionSelected}
          />,
        ]
      : []),
    ...(onCompareSelected && canCompare
      ? [
          <Button
            key="compare-completions"
            buttonText={`${t('compare-completions')} (${selectedItemsCount})`}
            buttonType={ButtonTypes.primaryOutlined}
            leftIcon="compare_arrows"
            leftIconClassName={materialSymbolsOutlined}
            onClick={onCompareSelected}
          />,
        ]
      : []),
  ];
}
